<template>
  <StyledDiv :backgroundColor="styled('black')" minHeight="250px">
    <StyledDiv height="unset" width="unset" margin="15px 0">
      <svg
        width="88px"
        height="88px"
        viewBox="0 0 88 88"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="Group" transform="translate(1.580000, 0.710000)">
            <path
              d="M30.66,30.79 L15.03,15.15"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M70.37,70.49 L54.73,54.86"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M54.73,30.79 L70.37,15.15"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M15.03,70.49 L30.66,54.86"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M8.8817842e-16,54.95 L13.61,54.95"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M13.61,54.95 L5.41,63.15"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M30.65,85.64 L30.65,72.03"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M54.86,85.64 L54.86,72.03"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M71.89,54.95 L85.5,54.95"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M71.89,54.95 L80.09,63.15"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M30.65,13.61 L30.65,0"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M54.86,13.61 L54.86,0"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M8.8817842e-16,30.74 L13.61,30.74"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M13.61,30.79 L5.41,22.58"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M71.89,30.74 L85.5,30.74"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M71.89,30.79 L80.09,22.58"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M20.03,42.7 L25.64,42.7"
              id="Path"
              stroke="#51B1E4"
              stroke-width="1.42"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M60.86,42.7 L66.48,42.7"
              id="Path"
              stroke="#51B1E4"
              stroke-width="1.42"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M42.75,25.15 L42.75,19.53"
              id="Path"
              stroke="#51B1E4"
              stroke-width="1.42"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M42.75,66.09 L42.75,60.47"
              id="Path"
              stroke="#51B1E4"
              stroke-width="1.42"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M30.65,13.61 L71.89,54.86"
              id="Path"
              stroke="#EFD215"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M54.86,13.61 L13.61,54.86"
              id="Path"
              stroke="#EFD215"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M54.86,72.03 L13.61,30.79"
              id="Path"
              stroke="#EFD215"
              stroke-width="1.42"
            ></path>
            <path
              d="M30.65,72.03 L71.89,30.79"
              id="Path"
              stroke="#EFD215"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M30.67,13.61 L30.67,72.03"
              id="Path"
              stroke="#EFD215"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M54.88,13.61 L54.88,72.03"
              id="Path"
              stroke="#EFD215"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M13.61,30.79 L71.89,30.79"
              id="Path"
              stroke="#EFD215"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M13.61,54.86 L71.89,54.86"
              id="Path"
              stroke="#EFD215"
              stroke-width="1.42"
            ></path>
            <circle
              id="Oval"
              fill="#51B1E4"
              fill-rule="nonzero"
              cx="42.75"
              cy="25.69"
              r="2.1"
            ></circle>
            <circle
              id="Oval"
              fill="#51B1E4"
              fill-rule="nonzero"
              cx="59.91"
              cy="42.84"
              r="1.99"
            ></circle>
            <circle
              id="Oval"
              fill="#51B1E4"
              fill-rule="nonzero"
              cx="25.64"
              cy="42.84"
              r="1.99"
            ></circle>
            <circle
              id="Oval"
              fill="#51B1E4"
              fill-rule="nonzero"
              cx="42.75"
              cy="59.96"
              r="1.97"
            ></circle>
            <polygon
              id="Path"
              stroke="#51B1E4"
              stroke-width="1.42"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="72.51 36.32 66.13 42.7 72.51 49.09 82.96 49.09 76.64 42.7 82.96 36.32"
            ></polygon>
            <polygon
              id="Path"
              stroke="#51B1E4"
              stroke-width="1.42"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="13.64 36.32 20.03 42.7 13.64 49.09 3.19 49.09 9.51 42.7 3.19 36.32"
            ></polygon>
            <polygon
              id="Path"
              stroke="#51B1E4"
              stroke-width="1.42"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="36.37 13.27 42.75 19.65 49.13 13.27 49.13 2.82 42.75 9.14 36.37 2.82"
            ></polygon>
            <polygon
              id="Path"
              stroke="#51B1E4"
              stroke-width="1.42"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="36.37 72.14 42.75 65.76 49.13 72.14 49.13 82.59 42.75 76.27 36.37 82.59"
            ></polygon>
          </g>
        </g>
      </svg>
    </StyledDiv>
    <StyledText
      :color="styled('white')"
      :mobileFontSize="styled('fontSize-tiny')"
      >Copyright © {{ currentYear }} | Literacy Loom</StyledText
    >
    <StyledText
      :mobileFontSize="styled('fontSize-tiny')"
      :color="styled('white')"
      >Park City, UT</StyledText
    >
  </StyledDiv>
</template>

<script>
import { StyledDiv, StyledText } from "../styled";
import StyleCompiler from "../styled/StyleCompiler";
import theImage from "../assets/images/dreamCatcher.png";
export default {
  components: {
    StyledDiv,
    StyledText
  },
  data() {
    return {
      Logo: theImage
    };
  },
  computed: {
    currentYear() {
      return 1900 + new Date().getYear();
    }
  },
  methods: {
    styled(e) {
      return StyleCompiler(e);
    }
  }
};
</script>

<style></style>
